// @flow

// Types
import type { DataTableState } from '../../types'

// Constants
import { SORT_AS_STRING } from 'fc-component-datatable'

export default function (): DataTableState {
  return {
    page: 0,
    perPage: 15,
    sortBy: null,
    sortAs: SORT_AS_STRING,
    sortDesc: false,
    booleanAttr: '',
    groupBy: '',
    groupOrder: [],
    filters: {},
    selectedRecords: [],
  }
}
